import {formatNumber} from "@/app/utils/Format";

export default function(number) {
    return new Handlebars.SafeString(formatNumber(number));
}